import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';


import {getTranslate, getActiveLanguage} from "react-localize-redux";
import FaQuestionCircle from "react-icons/lib/fa/question-circle";
import _ from 'lodash';

import * as actions from '../actions';

import FormInput from './forms/FormInput';

import {formatNumber} from '../utils/helpers';

class ZargenHOC extends Component {


    constructor(props) {
        super(props);
        this._callDebounce = _.debounce(this._callDebounce, 500);
    }

    _handleCustomInput(order, name, elementsDOM) {
        // get DOM element - field
        const elementDOM = elementsDOM[0]
        // set valid codes-values for the field
        const validCodes = [0, 1, 10, 11, 100, 101, 110, 111, 1000, 1001, 1010, 1011, 1100, 1001, 1110, 1111];
        let i;
        // get index of current element
        const currentIndex = validCodes.findIndex((code, index) => {
            return code === parseInt(elementDOM.value);
        });
        // increment action
        if (order === "up") {
            if (currentIndex === validCodes.length - 1) {
                return;
            }
            i = 1;
            // decrement action
        } else if (order === 'down') {
            if (currentIndex === 0) {
                return;
            };
            i = -1;
        }
        // get value of next element
        const nextCodeValue = validCodes[currentIndex + i];
        // update DOM field value
        elementDOM.value = formatNumber(nextCodeValue);
        // update state on debounce
        return this._callDebounce(nextCodeValue, name);
    }

    _callDebounce(codeValue, codeName) {
        // update field code value on app state
        this._updateField(codeValue, codeName);
    }

    _updateField(codeValue, codeName) {
        const setCodeName = (name, number, suffix = 'switch') => {
            return `${name.slice(0,1)}${number}_${suffix}`;
        }
        const defaultSwitchObj = {};
        defaultSwitchObj[`${codeName.slice(0,1)}23_switch`] = 0;
        defaultSwitchObj[`${codeName.slice(0,1)}45_switch`] = 0;
        defaultSwitchObj[`${codeName.slice(0,1)}67_switch`] = 0;
        defaultSwitchObj[`${codeName.slice(0,1)}81_switch`] = 0;

        const updateObject = (fields, obj = defaultSwitchObj, value = 1) => {
            const copiedObj = {...obj}
            fields.forEach((field) => {
                copiedObj[field] = value;
            });
            return copiedObj;
        };
        let switchObj;
        switch(codeValue) {

            case 1:
                switchObj = updateObject([setCodeName(codeName, 81)]);
            break;
            case 10:
                switchObj = updateObject([setCodeName(codeName, 67)]);
            break;
            case 11:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 81),
                        setCodeName(codeName, 67),
                    ]
                );
            break;
            case 100:
                switchObj = updateObject([setCodeName(codeName, 45)]);
            break;
            case 101:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 81),
                        setCodeName(codeName, 45),
                    ]
                );
            break;
            case 110:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 67),
                        setCodeName(codeName, 45),
                    ]
                );
            break;
            case 111:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 67),
                        setCodeName(codeName, 45),
                        setCodeName(codeName, 81),
                    ]
                );
            break;
            case 1000:
                switchObj = updateObject([setCodeName(codeName, 23)]);
            break;
            case 1001:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 23),
                        setCodeName(codeName, 81),
                    ]
                );
            break;
            case 1010:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 23),
                        setCodeName(codeName, 67),
                    ]
                );
            break;
            case 1011:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 67),
                        setCodeName(codeName, 23),
                        setCodeName(codeName, 81),
                    ]
                );
            break;
            case 1100:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 23),
                        setCodeName(codeName, 45),
                    ]
                );
            break;
            case 1110:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 23),
                        setCodeName(codeName, 45),
                        setCodeName(codeName, 67),
                    ]
                );
            break;
            case 1111:
                switchObj = updateObject(
                    [
                        setCodeName(codeName, 23),
                        setCodeName(codeName, 45),
                        setCodeName(codeName, 67),
                        setCodeName(codeName, 81),
                    ]
                );
            break;
            default:
                return this.props.changeData(
                    defaultSwitchObj,
                    null,
                    this.props.article.toUpperCase(),
                    this.props.articleID
                ).then((state) => {
                    return this.props.fetchImage(
                        state[this.props.article],
                        this.props.article,
                        this.props.articleID
                    );
                })

        }
        return this.props.changeData(
                switchObj,
                null,
                this.props.article.toUpperCase(),
                this.props.articleID
            ).then((state) => {
                return this.props.fetchImage(
                    state[this.props.article],
                    this.props.article,
                    this.props.articleID
                );
            })
    }

    render() {
        const {fieldCode, article} = this.props;
        return (
            <div className="col s6 custom-input-number__container">
                <FormInput
                    type='number'
                    name={this.props.inputName}
                    value={this.props.inputValue}
                    labelPosition='inline'
                    label={this.props.labelName}
                    labelStyle={{paddingRight: '10px', fontSize: "14px", color: "#003B71"}}
                    id='custom-input-number'
                    disabled={true}
                    readOnly={true}
                     />
                {/*
                <div className='custom-input-number__button-container'>
                    <div className={`custom-input-number__button ${this.props.className} custom-input-number__button--up`}>
                        <i className="small material-icons custom-input-number__icon"
                            onClick={this._handleCustomInput.bind(
                            this,
                            'up',
                            fieldCode,
                            document.getElementsByName(`${article.toUpperCase()}.${fieldCode}`)
                            )}
                        >arrow_drop_up</i>
                    </div>
                    <div className={`custom-input-number__button ${this.props.className} custom-input-number__button--down`}>
                        <i className="small material-icons custom-input-number__icon"
                            onClick={this._handleCustomInput.bind(
                            this,
                            'down',
                            fieldCode,
                            document.getElementsByName(`${article.toUpperCase()}.${fieldCode}`)
                            )}
                        >arrow_drop_down</i>
                    </div>
                </div>
                */}
            </div>
        )
    }

}

function mapStateToProps({locale}) {
    return {
        translate: getTranslate(locale),
    }
}

export default connect(mapStateToProps, actions)(ZargenHOC);




// WEBPACK FOOTER //
// ./src/components/ZargenSchurzenCode.js